import {management} from '../../../..'

import { GetManagementBySectorAndIntervalUseCase} from "./getManagementBySectorAndInterval";

import {ManagementRepository} from '../../../infra/knex/repositories/management'

export const getManagementByIdSectorAndIntervalUseCase=()=>{
  const repository=new ManagementRepository(management)

  const getManagementBySectorAndInterval= new GetManagementBySectorAndIntervalUseCase(repository)

  return getManagementBySectorAndInterval
}
